;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from './CheeseburgerButton.module.scss';

const CheeseburgerButton = ({ menuVisible, showIntro, ...rest }) => {
    return (
        <button
            {...rest}
            aria-label="Open the menu"
            className={cx(styles.root, {
                [styles.open]: menuVisible,
                [styles.showIntro]: showIntro,
            })}
        >
            <span role="presentation"></span>
            <span role="presentation"></span>
            <span role="presentation"></span>
            <span role="presentation"></span>
        </button>
    );
};

CheeseburgerButton.propTypes = {
    menuVisible: PropTypes.bool,
    showIntro: PropTypes.bool,
};

export default CheeseburgerButton;
